export default "__VITE_ASSET__q02vBQEa__"